// ============================================
// ChatAI - Main Application (ES6 Module)
// ============================================

import {
  useAppStore,
  useAuthStore,
  useHomeStore
} from './stores/index.js';

import { initializeFirebase } from './modules/auth/index.js';
import { initChoiceToggle } from './modules/chat/message-actions.js';

// ============================================
// Store Helpers
// ============================================

const getHomeStore = () => useHomeStore.getState();
const getAppStore = () => useAppStore.getState();
const getAuthStore = () => useAuthStore.getState();

// ============================================
// Global State - 하위 호환성 (점진적 제거 예정)
// ============================================

// getCurrentUser - authStore 사용
function getCurrentUser() {
  return getAuthStore()?.currentUser ?? null;
}
window.getCurrentUser = getCurrentUser;

// getAllPublishedContent - homeStore 사용
function getAllPublishedContent() {
  const store = getHomeStore();
  if (store) {
    return [...store.publishedContentCache.character, ...store.publishedContentCache.story];
  }
  return [];
}
window.getAllPublishedContent = getAllPublishedContent;

// currentTurnCount - appStore 연동
Object.defineProperty(window, 'currentTurnCount', {
  get: () => getAppStore()?.currentTurnCount ?? 0,
  set: (v) => getAppStore()?.setCurrentTurnCount(v)
});

// isProcessing - appStore 연동
Object.defineProperty(window, 'isProcessing', {
  get: () => getAppStore()?.isProcessing ?? false,
  set: (v) => getAppStore()?.setIsProcessing(v)
});

// currentUser, userNickname - authStore 연동
Object.defineProperty(window, 'currentUser', {
  get: () => getAuthStore()?.currentUser ?? null,
  set: (v) => getAuthStore()?.setCurrentUser(v)
});
Object.defineProperty(window, 'userNickname', {
  get: () => getAuthStore()?.userNickname ?? '',
  set: (v) => getAuthStore()?.setUserNickname(v)
});

// currentChatId, currentProfile, currentChatData - appStore 연동
Object.defineProperty(window, 'currentChatId', {
  get: () => getAppStore()?.currentChatId ?? null,
  set: (v) => getAppStore()?.setCurrentChatId(v)
});
Object.defineProperty(window, 'currentProfile', {
  get: () => getAppStore()?.currentProfile ?? null,
  set: (v) => getAppStore()?.setCurrentProfile(v)
});
Object.defineProperty(window, 'currentChatData', {
  get: () => getAppStore()?.currentChatData ?? null,
  set: (v) => getAppStore()?.setCurrentChatData(v)
});

// ============================================
// window._homeState, window._chatState 제거됨 (2026-01-06)
// 모든 모듈이 직접 store import 또는 app/state.js 사용
// ============================================

// ============================================
// 초기화
// ============================================

console.log('[app.js] ES6 모듈 로드');

// DOMContentLoaded에서 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeFirebase();
    initChoiceToggle();
  });
} else {
  initializeFirebase();
  initChoiceToggle();
}
